import { Box, IconButton, Typography } from "@mui/material";
import React, { useRef } from "react";
import { AddImageToInputIcon } from "../../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/AddImageToInputIcon";
import CloseIcon from "@mui/icons-material/Close";
import { getTruncatedFilename, WorkflowAppInputAndOutputTypes } from "../../../../Helper";

interface WorkflowInputImageProps {
  imageValue: File | string | null;
  handleInputImageChange: (activeAppId:string,image: File | null, dataType: string | null) => void
  handleClearImage: (() => void) | undefined;
  activeAppId:string;
  readOnly: boolean;
}
const WorkflowUploadInputImage = ({
  imageValue,
  handleInputImageChange,
  activeAppId,
  handleClearImage,
  readOnly,
}: WorkflowInputImageProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const openFileInput = () => {
    fileInputRef?.current?.click();
  };
  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && handleInputImageChange) {
      handleInputImageChange(activeAppId,file, WorkflowAppInputAndOutputTypes.Image);
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const file = event.dataTransfer.files?.[0];
    if (file && handleInputImageChange) {
      handleInputImageChange(activeAppId,file, WorkflowAppInputAndOutputTypes.Image);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const removeImage = () => {
    handleClearImage?.();
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the file input value
    }
  };
  return !readOnly ? (
    <Box className={`input-container`}>
      <input
        type="file"
        id="image-input"
        ref={fileInputRef}
        accept="image/jpeg, image/png"
        style={{ display: "none" }}
        onChange={handleImageUpload}
      />

      <Box className="workflow-uploaded-img-container">
        {!imageValue ? (
          <Box className="image-input">
            <Box onDragOver={handleDragOver} onDrop={handleDrop}>
              <Box
                onClick={openFileInput}
                sx={{
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <AddImageToInputIcon />
                <Typography className="input-drop-title">
                  Upload image
                </Typography>
                <Typography className="input-accept-note">
                  Format: jpg & Max file size: 5 MB
                </Typography>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              minHeight: "55px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: "8px",
              padding: " 8px",
              position: "relative",
              backgroundColor: " var(--A_backgroundColor97)",
              border: "1px solid var(--A_backgroundColor98)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={
                  typeof imageValue === "string"
                    ? imageValue
                    : imageValue
                    ? URL.createObjectURL(imageValue)
                    : undefined
                }
                className="uploaded-img"
                alt="Uploaded preview"
              />
              <Box sx={{
                display:"flex",
                flexWrap:"wrap"
              }}>
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0.5px",
                  color: "var(--Main_icons_color)",
                }}
              >
                {typeof imageValue === "string"
                  ? "Image.png"
                  : imageValue instanceof File
                  ? getTruncatedFilename(imageValue)
                  : ""}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0.5px",
                  color: "var(--Main_icons_color)",
                  opacity: "0.5",
                  margin:"0px 8px"
                }}
              >
                { imageValue instanceof File
                  ? (imageValue.size / (1024 * 1024)).toFixed(2) + " MB"
                  : ""
                  }
              </Typography>
            </Box>
            </Box>
            {imageValue && !readOnly ? (
              <Typography
                className="upload-another-img"
                onClick={openFileInput}
              >
                Change
              </Typography>
            ) : null}
          </Box>
        )}
      </Box>
    </Box>
  ) : (
    <Box
      sx={{
        width: "100%",
        height: "96px",
        borderRadius: "6px",
        margin: "8px 0px",
        border: "1px dotted #76CFEB",
        overflow: "hidden",
      }}
    >
      <img
        src={
          typeof imageValue === "string"
            ? imageValue
            : imageValue
            ? URL.createObjectURL(imageValue)
            : undefined
        }
        className="uploaded-img-readOnly"
        alt="Uploaded preview"
      />
    </Box>
  );
};

export default WorkflowUploadInputImage;
